import { Component, Input, OnInit, DoCheck } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Step10 } from '../../../../../shared/models/component-messages/mapaIN/step10';
import { CTRL_430 } from '../../../../validators/430/ctrl430';
import { MapaINControlNames } from '../../service/mapaINControleNames';
import { Validite } from '../../models/TypeValidite';
import { RadioCheckBoxEnum } from '../../../../common/radio.checkbox.enums';
@Component({
  selector: 'app-validite',
  templateUrl: './validite.component.html'
})
export class ValiditeComponent implements OnInit, DoCheck {

  @Input() uid = '';
  public current_uid = 'Validite';
  @Input() parentForm: FormGroup;
  	@Input() validite: Validite;
    @Input() disabled: boolean;
    public radioButtonValue;



    public rg1 = CTRL_430.id + '_1';

    public step10 = new Step10();

  constructor() { }

  /** Clé utilisée pour persister la sélection radio sur le parentForm */
  private get radioStorageKey(): string {
    return '_validiteRadioSelection_' + this.getUid();
  }

  public ngOnInit() {
    // Le parentForm persiste entre les changements d'onglets (contrairement à l'objet validite
    // qui peut être remplacé par un appel getAvis). On y stocke la sélection du radio button.
    if (this.parentForm[this.radioStorageKey] !== undefined) {
      this.radioButtonValue = this.parentForm[this.radioStorageKey];
    } else if (this.validite.dateJusquau !== null && this.validite.dateJusquau !== '' && this.validite.dateJusquau !== 'yyyy-MM-dd' && this.validite.dateJusquau !== undefined) {
      this.radioButtonValue = '';
    } else {
      this.radioButtonValue = 'duree';
    }
  }

  ngDoCheck() {
    const radioControlName = this.getUid() + '_SepAtt_dateJusquauRB';
    const control = this.parentForm?.controls?.[radioControlName];
    if (control) {
      this.parentForm[this.radioStorageKey] = control.value;
    }
  }

  rbValue(){
    if (this.parentForm.controls[this.getUid() + '_SepAtt_dateJusquauRB'].value === RadioCheckBoxEnum.emptyValue) {
      this.parentForm.addControl(this.getStepId() + this.rg1, new FormControl({ rgCtrls: MapaINControlNames.getCtrl_430Names_json() }));
    }
    return this.parentForm.controls[this.getUid() + '_SepAtt_dateJusquauRB'].value === RadioCheckBoxEnum.emptyValue;
  }








  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }

  getStepId() {
    return this.uid.substring(0, this.uid.indexOf("SepSep"));
  }
}

